(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  class MercuriasProductStickyAtc {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.productInfo = root.closest('product-info');
      this.form = document.getElementById(`product-form-${this.sectionId}`);
      this.sourceButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.button = root.querySelector('[data-product-sticky-atc-button]');
      this.label = root.querySelector('[data-product-sticky-atc-label]');
      this.price = root.querySelector('[data-product-sticky-atc-price]');
      this.purchasePanel = this.productInfo ? this.productInfo.querySelector('.product__purchase-panel') : null;
      this.mediaWrapper = this.productInfo ? this.productInfo.querySelector('.product__media-wrapper') : null;
      this.enabled = false;
      this.sourceButtonVisible = true;
      this.purchaseAreaReached = false;
      this.ticking = false;

      this.onClick = this.onClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.syncState = this.syncState.bind(this);

      if (!this.productInfo || !this.form || !this.sourceButton || !this.button) return;

      this.button.addEventListener('click', this.onClick);
      mobileQuery.addEventListener('change', this.onResize);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.unsubVariantChange =
        typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
          ? subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange)
          : null;

      this.observeSourceButton();
      this.observePurchasePanel();
      this.observeSourceState();
      this.syncState();
      this.onResize();
    }

    observeSourceButton() {
      if (!('IntersectionObserver' in window)) {
        this.sourceButtonVisible = false;
        return;
      }

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.sourceButtonVisible = Boolean(entry && entry.isIntersecting);
          this.syncVisibility();
        },
        { threshold: 0.2 }
      );

      this.visibilityObserver.observe(this.sourceButton);
    }

    observePurchasePanel() {
      if (!this.purchasePanel || !('IntersectionObserver' in window)) return;

      this.purchaseObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.purchaseAreaReached = Boolean(entry && entry.isIntersecting);
          this.syncVisibility();
        },
        {
          rootMargin: '0px 0px -20% 0px',
          threshold: 0,
        }
      );

      this.purchaseObserver.observe(this.purchasePanel);
    }

    observeSourceState() {
      if (!('MutationObserver' in window)) return;

      this.stateObserver = new MutationObserver(this.syncState);
      this.stateObserver.observe(this.sourceButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
      });
    }

    onResize() {
      this.enabled = mobileQuery.matches;
      this.syncVisibility();
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.syncVisibility();
      });
    }

    onClick() {
      if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit(this.sourceButton);
      } else {
        this.sourceButton.click();
      }
    }

    onVariantChange(event) {
      const data = event && event.data ? event.data : null;
      if (!data || data.sectionId !== this.sectionId) return;

      const sourcePrice = data.html
        ? data.html.querySelector(`#price-${this.sectionId} .price-item--sale`) ||
          data.html.querySelector(`#price-${this.sectionId} .price-item--regular`) ||
          data.html.querySelector(`#price-${this.sectionId} .price-item`)
        : null;

      if (sourcePrice && this.price) this.price.textContent = sourcePrice.textContent.trim();

      window.requestAnimationFrame(this.syncState);
    }

    syncState() {
      const disabled =
        this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';

      this.button.disabled = disabled;
      this.button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      this.button.classList.toggle('loading', this.sourceButton.classList.contains('loading'));

      const sourceLabel = this.sourceButton.querySelector('span:not(.sold-out-message)');
      if (sourceLabel && this.label) this.label.textContent = sourceLabel.textContent.trim();

      this.syncVisibility();
    }

    syncVisibility() {
      const shouldShow = this.enabled && !this.sourceButtonVisible && this.hasReachedPurchaseContext();
      this.root.hidden = !shouldShow;
      this.root.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.documentElement.classList.toggle('product-sticky-atc-is-visible', shouldShow);
    }

    hasReachedPurchaseContext() {
      if (this.purchaseAreaReached) return true;

      if (!this.mediaWrapper) return window.scrollY > window.innerHeight * 0.5;

      const mediaRect = this.mediaWrapper.getBoundingClientRect();
      return mediaRect.bottom < window.innerHeight * 0.62;
    }
  }

  const initStickyAtc = () => {
    document.querySelectorAll('[data-product-sticky-atc]').forEach((root) => {
      if (root.dataset.stickyAtcReady) return;
      root.dataset.stickyAtcReady = 'true';
      new MercuriasProductStickyAtc(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
